import http from './http';

/** File kho nội dung và nguồn lịch phát chỉ đọc được khi có JWT. */
export function isProtectedMedia(path?: string | null) {
  if (!path) return false;
  return path.includes('/api/files/cloud/') || path.includes('/api/files/playlist-source/');
}

export async function fetchMediaBlob(path: string) {
  const { data } = await http.get<Blob>(path, {
    responseType: 'blob',
    timeout: 1000 * 60 * 3,
  });
  return data;
}
